import React from 'react';
import { IExperiment } from '../../apiHooks/experimentApi.types';
import ExperimentListItemSlim from '../atoms/ExperimentListItemSlim';
import SearchModalComboboxOption from '../atoms/SearchModalComboboxOption';
import clsx from 'clsx';

interface IProps {
    results: IExperiment[];
    isLoading: boolean;
    query: string;
    totalCount?: number;
}

export default function SearchModalResultsTab(props: IProps) {
    const { results, isLoading, query, totalCount } = props;

    const showViewMore = isLoading || (totalCount !== undefined && totalCount > 5);
    const viewMorePath = query ? `/results/?search=${encodeURIComponent(query)}` : '/results/';

    return (
        <li className='p-2'>
            <div className='mb-2'>
                {isLoading
                    ? Array.from({ length: 5 }).map((_, index) => (
                          <ExperimentListItemSlim key={index} experiment={null} asLink={false} variant='focus' />
                      ))
                    : results.map((result) => {
                          const key = result.uuid ?? result.last_created_result.uuid;
                          const path = result.uuid
                              ? `/experiments/${result.uuid}/results/${result.last_created_result.uuid}/`
                              : `/results/${result.last_created_result.uuid}/`;

                          return (
                              <SearchModalComboboxOption path={path} key={key}>
                                  <ExperimentListItemSlim experiment={result} asLink={false} variant='focus' />
                              </SearchModalComboboxOption>
                          );
                      })}
            </div>
            {!isLoading && results.length === 0 && (
                <p className='px-3 py-8 text-center text-sm text-gray-500 dark:text-gray-400'>
                    No results found for "{query}"
                </p>
            )}
            {showViewMore && (
                <SearchModalComboboxOption path={viewMorePath} disableFocusStyling={isLoading}>
                    <p
                        className={clsx(
                            'px-3 py-2 text-center text-sm text-cyan-800',
                            isLoading ? '' : 'group-data-[focus]:text-white',
                        )}
                    >
                        View more results
                        {!isLoading && totalCount !== undefined ? ` (${totalCount} total)` : null}
                    </p>
                </SearchModalComboboxOption>
            )}
        </li>
    );
}
